// constants for chars limits
export const MAX_CHAR_EMAIL = 128;
export const MAX_CHAR_REGISTER_EMAIL = 80;
export const MAX_CHAR_SUPPORT_EMAIL = 256;
export const MAX_CHAR_BSP_SUPPORT_EMAIL = 100;
export const MAX_CHAR_NAME = 100;
export const MAX_CHAR_FIRST_NAME = 50;
export const MAX_CHAR_LAST_NAME = 80;
export const MAX_SUPPORT_EMAIL_NUMBER = 7;
export const MAX_CHAR_SUPPORT_PHONE = 44;
export const MAX_CHAR_COMPANY_NAME = 100;
export const MAX_CHAR_EMAIL_REASON = 1024;
export const MIN_CHAR_PASSWORD = 8;
export const MAX_CHAR_PASSWORD = 128;
export const MAX_CHAR_ACCOUNT_ALIAS = 64;
export const MAX_CHAR_PROBLEM_DESCRIPTION = 5000;
